import style from './ReEvalSentenceItem.module.scss';
import { formatTimeToShortAMPM, convertUTCtoLocalTime } from '@/utils/index';
import LightEditor from '@/components/Editor/LightEditor';
import { useState } from 'react';
import { Sentence } from '@ax/constants/src/sentence.ts';

interface ReevalSentenceItemProps {
  sentence: Sentence;
  onBlur?: (content: string, sentence: any) => void;
}

const ReevalSentenceItem = ({ sentence, onBlur }: ReevalSentenceItemProps) => {
  const [sentenceContent, setSentenceContent] = useState(sentence.Content);

  const handleReevalSentenceChange = (content: string) => {
    setSentenceContent(content);
  };

  const handleSentenceEditorBlur = () => {
    onBlur?.(sentenceContent, sentence);
  };

  return (
    <div className={`${style.note_eval_sentences_container}`}>
      <div className={`${style.node_eval_heading_container}`}>
        <strong className={style.reeval__sentence__metadata}>Progress #{sentence.Order}</strong>
        <strong className={style.reeval__sentence__metadata}>
          Time {formatTimeToShortAMPM(convertUTCtoLocalTime(sentence.CreatedAt))}
        </strong>
        <LightEditor
          isEditable={!sentence.isLoading}
          onEditorBlur={() => handleSentenceEditorBlur()}
          onContentChange={(content) => handleReevalSentenceChange(content)}
          content={sentence.Content}
        />
      </div>
    </div>
  );
};

export default ReevalSentenceItem;
